import { useMatchRoute, useParams, Outlet } from '@tanstack/react-router';
import { useUserPermissions } from '@anytag/auth';
import { useTalentAgencyQuery, TalentAgencyWithCompanies } from '@anytag/graphql';
import { ButtonLink, RenderDataWithFallback } from '@anytag/shared-atoms';
import { useQueryHelper } from '@anytag/shared-hooks';
import { Header } from '@anytag/shared-molecules';
import { TalentAgencyTabs } from '@anytag/shared-organisms';
import { TalentAgencyDetailsProvider } from './TalentAgencyDetailsContext';

export const TalentAgencyDetails = () => {
  const { hideAddUserBtn } = useUserPermissions();
  const { t, navigate, enqueueSnackbar } = useQueryHelper();
  const params = useParams({ from: '/_private-routes/talent-agency/$id' });
  const match = useMatchRoute();
  const { data, loading } = useTalentAgencyQuery({
    fetchPolicy: 'network-only',
    variables: { pk: Number(params.id) },
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
      navigate({ to: '/talent-agency' });
    }
  });

  const talentAgency = data?.talentAgency;
  const hasAddUserLink = !hideAddUserBtn && match({ to: '/talent-agency/$id/users' });

  return (
    <RenderDataWithFallback loading={loading} hasNoData={!talentAgency}>
      <TalentAgencyDetailsProvider values={{ talentAgency: talentAgency as TalentAgencyWithCompanies }}>
        <div>
          <Header>
            {hasAddUserLink ? (
              <ButtonLink
                to="/user/add"
                variant="solid"
                title={t('Button.Add User')}
                className="ml-auto min-w-27 capitalize"
                prefixIcon={{ icon: 'plus', size: '10px' }}
              />
            ) : null}
          </Header>

          <div>
            <TalentAgencyTabs talentAgencyId={Number(talentAgency?.id)} />
            <Outlet />
          </div>
        </div>
      </TalentAgencyDetailsProvider>
    </RenderDataWithFallback>
  );
};
